import React from 'react';
import { Link } from 'react-router-dom';
import { useAuthContext } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';

const Landing = () => {
  const { isAuthenticated } = useAuthContext();
  const navigate = useNavigate();
  
  React.useEffect(() => {
    // Redirect to dashboard if authenticated
    if (isAuthenticated) {
      navigate('/dashboard');
    }
  }, [isAuthenticated, navigate]);
  
  return (
    <div className="flex flex-col items-center justify-center min-h-[80vh] text-center px-4">
      <h1 className="text-4xl md:text-5xl font-bold mb-6 text-blue-600">TodoWebSmart</h1>
      <p className="text-xl mb-8 max-w-2xl text-gray-600">
        Tieni traccia delle tue attività, imposta le priorità e non perdere mai una scadenza con la nostra semplice ed efficace applicazione per liste di cose da fare.
      </p>
      
      <div className="flex flex-col sm:flex-row gap-4">
        <Link 
          to="/register" 
          className="px-8 py-3 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors font-medium text-lg"
        >
          Registrati
        </Link>
        <Link 
          to="/login" 
          className="px-8 py-3 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300 transition-colors font-medium text-lg"
        >
          Login
        </Link>
      </div>
      
      <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl">
        <div className="p-6 bg-white rounded-lg shadow-md">
          <div className="text-blue-500 mb-4">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
            </svg>
          </div>
          <h3 className="text-xl font-semibold mb-2">Organizzazione delle Attività</h3>
          <p className="text-gray-600">Tieni le tue attività organizzate e facilmente accessibili in un unico posto.</p>
        </div>
        
        <div className="p-6 bg-white rounded-lg shadow-md">
          <div className="text-blue-500 mb-4">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <h3 className="text-xl font-semibold mb-2">Date di Scadenza</h3>
          <p className="text-gray-600">Imposta le date di scadenza per non perdere mai più le scadenze importanti.</p>
        </div>
        
        <div className="p-6 bg-white rounded-lg shadow-md">
          <div className="text-blue-500 mb-4">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4h13M3 8h9m-9 4h6m4 0l4-4m0 0l4 4m-4-4v12" />
            </svg>
          </div>
          <h3 className="text-xl font-semibold mb-2">Livelli di Priorità</h3>
          <p className="text-gray-600">Assegna livelli di priorità per concentrarti su ciò che conta di più.</p>
        </div>
      </div>
    </div>
  );
};

export default Landing;
